/* eslint-disable no-unused-vars */
import cookie from 'webmd-cookie';

const suppressAutoHover = {
	excludedTopicIDs: ['2951', '1812', '7002'],
	dfpServedTopicIDS: ['3554', '1625', '1626', '2951', '2945'],
	excludeHref: 'food-fitness-planner|breakthrough-research-16',
	excludeHostname: /^fit\.|beta\.|cnslx03d|doctor\./,
	cookieName: 'nls2',
	cookieExpireDays: 7,

	/**
	 * Determine if the overlay should display on this page based on cookie.
	 *
	 * @returns Boolean False if the Auto newsletter cookie value a is not equal to 0 .
	 */
	nlCookieCheck() {
		let showAutoHover = false;
		if (cookie(this.cookieName) == null) {
			/*
			 * set up cookie with payload
			 * Overlay is not active
			 */

			/*
			 * To keep the cookie small we will use value 0 in the cookie instead of a boolean false
			 * We will assume that if the cookie.a parameter is defined at all then we are no longer
			 * active (so don't try setting data.a=1 to mean it is active)
			 */
			const cookieData = {
				a: 0,
			};
			cookie(this.cookieName, JSON.stringify(cookieData), { expires: this.cookieExpireDays });
			showAutoHover = true;
		} else {
			// if cookie is available
			const payload = JSON.parse(cookie(this.cookieName));
			if (payload && payload.a === 0) {
				// Do not show hover as cookiee is not expired and value is 0
				showAutoHover = false;
			} else {
				showAutoHover = true;
			}
		}
		return showAutoHover;
	},

	/**
	 * Determine if the overlay should <em>not</em> display on this page.
	 *
	 * @returns Boolean True if the newsletter hover should be excluded on this page.
	 */
	isPageExcluded() {
		let isExcluded = false;

		/*
		 * suppress Auto NL hover across site except sitefronts pages
		 * https://jira.internetbrands.com/browse/PPE-310965
		 */
		// eslint-disable-next-line no-undef
		if (webmd.sitefrontsConfig && webmd.sitefrontsConfig.nav) {
			/*
			 * suppress automatic overlay on Pets TOC pages
			 * https://jira.webmd.net/browse/PPE-226977
			 */
			if (window.s_business_reference === 'TOC - Channel' || window.s_business_reference === 'drug monograph') {
				this.debug('NL hover on Sitefronts TOC channel & drug monograph is suppressed as per requirement');
				isExcluded = true;
			}
		} else {
			isExcluded = true;
		}

		// Provide an option to enable auto hover if needed
		if (window.enableAutoNL) {
			isExcluded = false;
		}

		// If we make it this far, we are not excluded, yay!
		return isExcluded;
	},
};
export default suppressAutoHover;
